import { render, staticRenderFns } from "./RelatorioLucro.vue?vue&type=template&id=6a6f634c&"
import script from "./RelatorioLucro.vue?vue&type=script&lang=js&"
export * from "./RelatorioLucro.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioLucro.vue?vue&type=style&index=0&id=6a6f634c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports